import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, useMap} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import 'proj4leaflet'; // Assuming proj4leaflet is used for custom CRS
import Proj from "proj4leaflet";
const MAX_ZOOM = 16;
const TILE_SIZE = 512;

const extent = Math.sqrt(2) * 6371007.2;
const resolutions = Array(MAX_ZOOM + 1)
  .fill()
  .map((_, i) => extent / TILE_SIZE / Math.pow(2, i - 1));

export const ARCTIC_LAEA = new Proj.CRS(
  "EPSG:3575",
  "+proj=laea +lat_0=90 +lon_0=10 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
  {
    origin: [-extent, extent],
    bounds: L.bounds(L.point(-extent, extent), L.point(extent, -extent)),
    resolutions: resolutions,
  }
);

const ARCTIC_TILES_URL =
  "https://tile.gbif.org/3575/omt/{z}/{x}/{y}@4x.png?style=osm-bright-en";

// Define another CRS (for example WGS84)
const WGS84 = L.CRS.EPSG4326; 

const App = () => {
  const [activeCRS, setActiveCRS] = useState(ARCTIC_LAEA); // Default CRS
  const [mapCenter, setMapCenter] = useState([90, 0]); // Example map center

  // Function to toggle between CRS
  const toggleCRS = () => {
    setActiveCRS(activeCRS === ARCTIC_LAEA ? WGS84 : ARCTIC_LAEA); // Switch between two CRS
  console.log(activeCRS)
  };

  return (
    <div>
      <div className="App pt-0 -mt-0 mb-0 min-h-screen relative pt-[9rem] -mt-[4.25rem] md:-mt-[4.25rem] lg:-mt-[4.25rem] mb-[-3.25rem]  md:mb-[-2.25rem] lg:mb-[-6.25rem] xl:mb-[-13.25rem]">
      
      
       
      <div className="Map-container z-3">
        
        <button onClick={toggleCRS}>Toggle CRS</button>
        
       {/* Recreate the MapContainer when CRS changes by using the `key` prop */}
      <MapContainer
        key={activeCRS.code} // This forces re-render of the MapContainer when CRS changes
        center={mapCenter}
        crs={activeCRS}
        zoom={2}
        className="Map"
      >
        <TileLayer
          url={ARCTIC_TILES_URL} // Ensure tile layer is compatible with the CRS
          attribution="Map data attribution"
        />
        <MapUpdater center={mapCenter} />
      </MapContainer>
    </div>
    </div>
    </div>
  );
};

// Component for updating the map view based on center
const MapUpdater = ({ center }) => {
  const map = useMap();

  useEffect(() => {
    if (map) {
      map.setView(center);
    }
  }, [center, map]);

  return null;
};

export default App;
